// extracted by mini-css-extract-plugin
module.exports = {"head":"header_head__ytskw","spanDark":"header_spanDark__3ZEXB","spanLight":"header_spanLight__3hzUt","dark":"header_dark__1lCUz","light":"header_light__2HLtw"};